/* Options:
Date: 2024-03-08 16:29:04
Version: 6.110
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://bysservices.dabto.com

//GlobalNamespace:
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion:
//AddDescriptionAsComments: True
//IncludeTypes:
//ExcludeTypes:
//DefaultImports:
*/

import { BysBelgeDagitim, BysDagitimBirim } from "./bys.models";


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPost
{
}

export class BaseRequest<E>
{

    public constructor(init?: Partial<BaseRequest<E>>) { (Object as any).assign(this, init); }
}

export class BaseResponse
{
    public result: boolean;
    public errorCode: string;
    public errorMessage: string;
    public errors: string[];
    public warnings: string[];
    public errorDetails: string[];

    public constructor(init?: Partial<BaseResponse>) { (Object as any).assign(this, init); }
}

export class BYS_BelgeIncele_Response extends BaseResponse
{
    public dosyaContent: string;

    public constructor(init?: Partial<BYS_BelgeIncele_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BaseCursorDto implements IBaseCursorDto
{

    public constructor(init?: Partial<BaseCursorDto>) { (Object as any).assign(this, init); }
}

export class BysGorevDetayDto
{
    public aciklama: string;
    public gorevAd: string;
    public gorevKod: number;
    public gorevTuru: number;
    public imzaEh: string;
    public imzaOnayTuru: string;
    public kod: number;
    public mailEh: string;
    public personelKod?: number;
    public rolAd: string;
    public smsEh: string;
    public sonrakiGorevKod?: number;
    public zamanDamgaEh: string;

    public constructor(init?: Partial<BysGorevDetayDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export interface IBaseCursorDto
{
}

export class Bys_GidenEvrakTarihNo_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<Bys_GidenEvrakTarihNo_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GelenBilgiGirisiGet_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GelenBilgiGirisiGet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GenBelgeTuruSDP_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GenBelgeTuruSDP_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GetUstBilgi_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: any[];

    public constructor(init?: Partial<BYS_GetUstBilgi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBelgeDagitim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBelgeDagitim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_SetDagitimKaydet_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<BYS_SetDagitimKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/PgBysGet/GetBysBelgeDagitim")
export class BYS_GetBelgeDagitim extends BaseRequest<BYS_GetBelgeDagitim> implements IReturn<BYS_GetBelgeDagitim>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_GetBelgeDagitim>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetBelgeDagitim'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetBelgeDagitim(); }
}

export class BYS_BelgeIlgiKaydet_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<BYS_BelgeIlgiKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysBelgeIlgi_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysBelgeIlgi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GetBysIlgi_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GetBysIlgi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysBelgeEk_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value:any[];

    public constructor(init?: Partial<BYS_AraBysBelgeEk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GetBysBelge_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GetBysBelge_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GetBysParametre_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GetBysParametre_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GenKodDetayGet_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GenKodDetayGet_Response>) { super(init); (Object as any).assign(this, init); }
}


export class BYS_DosyaPlanKriter_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_DosyaPlanKriter_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_SetEkBelgeKaydet_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<BYS_SetEkBelgeKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_SetBelgeKaydet_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<BYS_SetBelgeKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GetEkBelge_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GetEkBelge_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_DosyaPathAl_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_DosyaPathAl_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_SetBelgeIcerikKaydet_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<BYS_SetBelgeIcerikKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_BysBelgeIlgiAra_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_BysBelgeIlgiAra_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysBelgeDetay_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysBelgeDetay_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_BysBelgeAsli_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_BysBelgeAsli_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GelenEvrakGonder_Response extends BaseResponse
{
    public poDonenEvrakNo: number;

    public constructor(init?: Partial<BYS_GelenEvrakGonder_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_HavaleIadeGerekce_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_HavaleIadeGerekce_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_ImzaGorevlerimiGetirTum_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_ImzaGorevlerimiGetirTum_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_EkBelgeGetir_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_EkBelgeGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_ArsivGetir_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_ArsivGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GetArsivSurecGoster_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GetArsivSurecGoster_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GetSurecIzle_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GetSurecIzle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_BelgeUrlGetir_Response extends BaseResponse
{
    public dosyaIcerik: string;

    public constructor(init?: Partial<BYS_BelgeUrlGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_ArsivBelgeUrlGetir_Response extends BaseResponse
{
    public dysResult: string;

    public constructor(init?: Partial<BYS_ArsivBelgeUrlGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_EkBelgeUrlGetir_Response extends BaseResponse
{
    public pBelgeAdi: string;

    public constructor(init?: Partial<BYS_EkBelgeUrlGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class FnIntResponse extends BaseResponse
{
    public fnResult: number;

    public constructor(init?: Partial<FnIntResponse>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_TokenKontrol_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_TokenKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_KullaniciBilgileriYukle_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_KullaniciBilgileriYukle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_DmlBysDegisen_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<BYS_DmlBysDegisen_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_GorevDetayGetir_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_GorevDetayGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysIlgiEk_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysIlgiEk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_ImzaDosyaGoster_Response extends BaseResponse
{
    public dosyaIcerik: string;

    public constructor(init?: Partial<BYS_ImzaDosyaGoster_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_TaslakWordBelgeGetir_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_TaslakWordBelgeGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysParametre_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysParametre_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysBelgeIcerik_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysBelgeIcerik_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_BelgeTaslakGoster_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public poAltBilgi: BaseCursorDto[];

    public constructor(init?: Partial<BYS_BelgeTaslakGoster_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_WordAraBysSurec_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_WordAraBysSurec_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysSurec_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysSurec_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysSurecDetay_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysSurecDetay_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysBelgeDetay_Response2 extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: any[];


    public constructor(init?: Partial<BYS_AraBysBelgeDetay_Response2>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysGorev_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysGorev_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysGorevDetay_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysGorevDetay_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_IadeGerekce_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value:any[];

    public constructor(init?: Partial<BYS_IadeGerekce_Response>) { super(init); (Object as any).assign(this, init); }
}




export class BYS_KarsilastirmaGetir_Response extends BaseResponse
{
    public pioVarMi: number;
    public pioDosya: Object;

    public constructor(init?: Partial<BYS_KarsilastirmaGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_KisiBilgisiGetir_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_KisiBilgisiGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_TopluDagitimKaydet_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<BYS_TopluDagitimKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_BirimSurecDoldur_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_BirimSurecDoldur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_TaslakSablonDoldur_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_TaslakSablonDoldur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_BelgeImzalari_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value:any[];


    public constructor(init?: Partial<BYS_BelgeImzalari_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysBelgeTarama_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysBelgeTarama_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_TaslakBilgiAlanlariYukle_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_TaslakBilgiAlanlariYukle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Bys_SpBelgeKaydet_Response extends BaseResponse
{
    public pioKod: number;
    public piEvrakTarih: string;
    public piEvrakNo: number;

    public constructor(init?: Partial<Bys_SpBelgeKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_AraBysEvrak_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<BYS_AraBysEvrak_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_SetUstBilgiSurecUpdate_Response extends BaseResponse
{
    public poReferansKod: number;
    public poBelgeKod: number;

    public constructor(init?: Partial<BYS_SetUstBilgiSurecUpdate_Response>) { super(init); (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

export class Bys_GelenEvrakOnay_Response extends BaseResponse
{
    public poDonenEvrakNo: number;

    public constructor(init?: Partial<Bys_GelenEvrakOnay_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GelenEvrakOnay")
export class Bys_GelenEvrakOnay_Request extends BaseRequest<Bys_GelenEvrakOnay_Response> implements IReturn<Bys_GelenEvrakOnay_Response>
{
    public piBelgeKod: number;
    public piDagitimKod: number;
    public piEvrakTarih: string;
    public piEvrakNo: number;
    public piGenelArsivKod: number;
    public piZimmetTarih: string;
    public piZimmetNo: number;
    public piBirimNot: string;

    public constructor(init?: Partial<Bys_GelenEvrakOnay_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_GelenEvrakOnay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_GelenEvrakOnay_Response(); }
}

// @Route("/BYS/GelenEvrakReddet")
export class Bys_GelenEvrakReddet_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piDagitimKod: number;
    public piRedNedeni: string;

    public constructor(init?: Partial<Bys_GelenEvrakReddet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_GelenEvrakReddet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/GidenEvrakTarihNo")
export class Bys_GidenEvrakTarihNo extends BaseRequest<Bys_GidenEvrakTarihNo_Response> implements IReturn<Bys_GidenEvrakTarihNo_Response>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<Bys_GidenEvrakTarihNo>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_GidenEvrakTarihNo'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_GidenEvrakTarihNo_Response(); }
}

// @Route("/BYS/GelenBilgiGirisGet")
export class BYS_GelenBilgiGirisiGet extends BaseRequest<BYS_GelenBilgiGirisiGet_Response> implements IReturn<BYS_GelenBilgiGirisiGet_Response>
{
    public piKod?: number;
    public piReferansKod?: number;
    public piBirimKod?: number;
    public piGelenGiden?: string;
    public piBelgeTuru?: string;
    public piGelenBirimKod?: number;
    public piGelenBirimAciklama?: string;
    public piBelgeTarih?: string;
    public piBelgeNo?: string;
    public piGenelDosyaNo?: number;
    public piDosyaPlanKod?: string;
    public piBelgeTuruKod?: number;
    public piBelgeAdi?: string;
    public piBelgeAciklama?: string;
    public piAnahtarKelime?: string;
    public piDagitimSekli?: string;
    public piOncelikDurumu?: string;
    public piBeklenenDonusTarih?: string;
    public piPersonelKod?: number;
    public piKisiKod?: number;
    public piTcknNo?: number;
    public piGuvenlikDurumu?: number;
    public piGecerliSure?: number;
    public piDilKod?: number;
    public piBelgeIcerikKod?: number;
    public piBilgiEdinmeEh?: string;
    public piKisiselEh?: string;
    public piTelifKapsamindaEh?: string;
    public piKelimeIslemci?: string;
    public piBarkodNo?: string;
    public piGelisTurKod?: number;
    public piAsliAlindiEh?: string;
    public piEvrakTuru?: string;
    public piTransferTarih?: string;
    public piArsivTarih?: string;
    public piImhaTarih?: string;
    public piUretimTarih?: string;
    public piUretimAciklama?: string;
    public piKlasorKod?: number;
    public piGonderAlTarih?: string;
    public piYazilimVersion?: string;
    public piGenelArsivKod?: number;
    public piStatusu?: number;
    public piDilekceEh?: string;
    public piEvrakTarih?: string;
    public piEvrakNo?: number;
    public piZimmetTarih?: string;
    public piZimmetNo?: number;
    public piOzelNo?: string;
    public piPafta?: string;
    public piAda?: number;
    public piParsel?: number;
    public piParselKod?: number;
    public piGsmTelefonNo?: string;
    public piEMail?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;
    public piSiralama?: string;
    public piGelenBirimAd?: string;
    public piBirimAd?: string;
    public piGelenEvrakDurumu?: string;

    public constructor(init?: Partial<BYS_GelenBilgiGirisiGet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenBilgiGirisiGet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GelenBilgiGirisiGet_Response(); }
}

// @Route("/BYS/GelenBelgeGirisSil")
export class BYS_GelenBelgeGirisSil_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piAciklama: string;

    public constructor(init?: Partial<BYS_GelenBelgeGirisSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenBelgeGirisSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Bys/GenBelgeTuruSDP")
export class BYS_GenBelgeTuruSDP extends BaseRequest<BYS_GenBelgeTuruSDP_Response> implements IReturn<BYS_GenBelgeTuruSDP_Response>
{
    public piKod?: number;
    public piAd?: string;
    public piUstKod?: number;
    public piAktifEh?: string;
    public piDosyaPlanKod?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_GenBelgeTuruSDP>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GenBelgeTuruSDP'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GenBelgeTuruSDP_Response(); }
}

// @Route("/BYS/GetUstBilgi")
export class BYS_GetUstBilgi extends BaseRequest<BYS_GetUstBilgi_Response> implements IReturn<BYS_GetUstBilgi_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_GetUstBilgi>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetUstBilgi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetUstBilgi_Response(); }
}

// @Route("/BYS/AraBelgeDagitim")
export class BYS_AraBelgeDagitim extends BaseRequest<BYS_AraBelgeDagitim_Response> implements IReturn<BYS_AraBelgeDagitim_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBirimKod?: number;
    public piAciklama?: string;
    public piDagitimSekli?: string;
    public piIslemTuru?: string;
    public piRedNedeni?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBelgeDagitim>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBelgeDagitim'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBelgeDagitim_Response(); }
}

// @Route("/BYS/SetDagitimKaydet")
export class BYS_SetDagitimKaydet extends BaseRequest<BYS_SetDagitimKaydet_Response> implements IReturn<BYS_SetDagitimKaydet_Response>
{
    public piIslemType: number;
    public piBelgeKod?: number;
    public piBirimKod?: number;
    public piAciklama?: string;
    public piDagitimSekli?: string;
    public piIslemTuru?: string;
    public piRedNedeni?: string;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piColumnList?: string;

    public constructor(init?: Partial<BYS_SetDagitimKaydet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SetDagitimKaydet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SetDagitimKaydet_Response(); }
}

// @Route("/BYS/DagitimBirim")
export class BYS_DagitimBirim extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_DagitimBirim>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_DagitimBirim'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeIlgiKaydet")
export class BYS_BelgeIlgiKaydet extends BaseRequest<BYS_BelgeIlgiKaydet_Response> implements IReturn<BYS_BelgeIlgiKaydet_Response>
{
    public piIslemType: number;
    public piBelgeKod?: number;
    public piBirimKod?: number;
    public piIlgiTuru?: string;
    public piReferansKod?: number;
    public piEvrakTarih?: string;
    public piEvrakNo?: number;
    public piIlgiAciklama?: string;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piColumnList?: string;

    public constructor(init?: Partial<BYS_BelgeIlgiKaydet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeIlgiKaydet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BelgeIlgiKaydet_Response(); }
}

// @Route("/BYS/AraBysBelgeIlgi")
export class BYS_AraBysBelgeIlgi extends BaseRequest<BYS_AraBysBelgeIlgi_Response> implements IReturn<BYS_AraBysBelgeIlgi_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBirimKod?: number;
    public piIlgiTuru?: string;
    public piReferansKod?: number;
    public piEvrakTarih?: string;
    public piEvrakNo?: number;
    public piIlgiAciklama?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysBelgeIlgi>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysBelgeIlgi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysBelgeIlgi_Response(); }
}

// @Route("/BYS/GetBysIlgi")
export class BYS_GetBysIlgi extends BaseRequest<BYS_GetBysIlgi_Response> implements IReturn<BYS_GetBysIlgi_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_GetBysIlgi>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetBysIlgi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetBysIlgi_Response(); }
}

// @Route("/BYS/AraBysBelgeEk")
export class BYS_AraBysBelgeEk extends BaseRequest<BYS_AraBysBelgeEk_Response> implements IReturn<BYS_AraBysBelgeEk_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piReferansKod?: number;
    public piBelgeTipKod?: number;
    public piBelgeTuruKod?: number;
    public piBelgePath?: string;
    public piBelgeAd?: string;
    public piBelgeDysKod?: string;
    public piBelgeTarih?: string;
    public piBelgeNo?: number;
    public piBelgeAciklama?: string;
    public piAdetSayfa?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysBelgeEk>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysBelgeEk'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysBelgeEk_Response(); }
}

// @Route("/BYS/GetBysBelge")
export class BYS_GetBysBelge extends BaseRequest<BYS_GetBysBelge_Response> implements IReturn<BYS_GetBysBelge_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_GetBysBelge>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetBysBelge'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetBysBelge_Response(); }
}

// @Route("/BYS/GetBysParametre")
export class BYS_GetBysParametre extends BaseRequest<BYS_GetBysParametre_Response> implements IReturn<BYS_GetBysParametre_Response>
{
    public piKod?: number;
    public piModulKod?: number;
    public piRaporBaslik1?: string;
    public piRaporBaslik2?: string;
    public piRaporBaslik3?: string;
    public piRaporBaslik4?: string;
    public piCalismaPath?: string;
    public piBelgeRootPath?: string;
    public piEimzaEh?: string;
    public piDilKod?: number;
    public piGenelBirimKod?: number;
    public piMevzuatLink?: string;
    public piEmailBaslikSatir?: string;
    public piEmailSonucSatir?: string;
    public piEvrakNoOtoEh?: string;
    public piSistemBelgeOtoArsivEh?: string;
    public piBelgeDogrulamaUrl?: string;
    public piZamanDamgaUrl?: string;
    public piZamanDamgaKullanici?: string;
    public piZamanDamgaSifre?: string;
    public piZamanDamgaProv?: string;
    public piAZamanDamgaUrl?: string;
    public piAZamanDamgaKullanici?: string;
    public piAZamanDamgaSifre?: string;
    public piAZamanDamgaProv?: string;
    public piEImzaUrl?: string;
    public piYaziMudurKod?: number;
    public piOtoOnayEh?: string;
    public piGelenBelgeOtoNoEh?: string;
    public piBelgeIcerikKod?: number;
    public piGelisTurKod?: number;
    public piOnayTurKod?: number;
    public piDysTuru?: string;
    public piDysServisAdres?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_GetBysParametre>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetBysParametre'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetBysParametre_Response(); }
}

// @Route("/BYS/GenKodDetayGet", "POST")
export class BYS_GenKodDetayGet extends BaseRequest<BYS_GenKodDetayGet_Response> implements IReturn<BYS_GenKodDetayGet_Response>
{
    public piKod?: number;
    public piAd?: string;
    public piAnaKod?: number;
    public piOzelKod?: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_GenKodDetayGet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GenKodDetayGet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GenKodDetayGet_Response(); }
}

export class BYS_RaporBelgeKaydet_Response extends BaseResponse
{
    public poReferansKod: number;
    public poBelgeKod: number;

    public constructor(init?: Partial<BYS_RaporBelgeKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/RaporBelgeKaydet")
export class BYS_RaporBelgeKaydet_Request extends BaseRequest<BYS_RaporBelgeKaydet_Response> implements IReturn<BYS_RaporBelgeKaydet_Response>
{
    public piRaporAdi: string;
    public piTabloAdi: string;
    public piReferansKod: number;
    public piAltTabloAdi: string;
    public piAltReferansKod: number;
    public piPersonelKod: number;
    public piKisiKod: number;
    public piTckn: number;
    public piArsivKod: number;
    public piBirimKod: number;
    public piBelgeAciklama: string;

    public constructor(init?: Partial<BYS_RaporBelgeKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_RaporBelgeKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_RaporBelgeKaydet_Response(); }
}

// @Route("/BYS/DosyaPlanKriter")
export class BYS_DosyaPlanKriter extends BaseRequest<BYS_DosyaPlanKriter_Response> implements IReturn<BYS_DosyaPlanKriter_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_DosyaPlanKriter>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_DosyaPlanKriter'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_DosyaPlanKriter_Response(); }
}

// @Route("/BYS/SetEkBelgeKaydet")
export class BYS_SetEkBelgeKaydet extends BaseRequest<BYS_SetEkBelgeKaydet_Response> implements IReturn<BYS_SetEkBelgeKaydet_Response>
{
    public piIslemType: number;
    public piBelgeKod?: number;
    public piReferansKod?: number;
    public piBelgeTipKod?: number;
    public piBelgeTuruKod?: number;
    public piBelgePath?: string;
    public piBelgeAd?: string;
    public piBelgeDysKod?: string;
    public piBelgeTarih?: string;
    public piBelgeNo?: number;
    public piBelgeAciklama?: string;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piAdetSayfa?: string;
    public piColumnList?: string;
    public piBoyut?: number;
    public piSira?: number;

    public constructor(init?: Partial<BYS_SetEkBelgeKaydet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SetEkBelgeKaydet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SetEkBelgeKaydet_Response(); }
}

// @Route("/BYS/SetBelgeKaydet")
export class BYS_SetBelgeKaydet extends BaseRequest<BYS_SetBelgeKaydet_Response> implements IReturn<BYS_SetBelgeKaydet_Response>
{
    public piIslemType: number;
    public piBelgeKod?: number;
    public piBelgePath?: string;
    public piBelgeAd?: string;
    public piBelgeDysKod?: string;
    public piBelgeTipKod?: number;
    public piEimzaBelgeAd?: string;
    public piEimzaBelgeDysKod?: string;
    public piEimzaBelgeTipKod?: number;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piEypDysId?: string;
    public piColumnList?: string;

    public constructor(init?: Partial<BYS_SetBelgeKaydet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SetBelgeKaydet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SetBelgeKaydet_Response(); }
}

// @Route("/BYS/GetEkBelge")
export class BYS_GetEkBelge_Request extends BaseRequest<BYS_GetEkBelge_Response> implements IReturn<BYS_GetEkBelge_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_GetEkBelge_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetEkBelge_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetEkBelge_Response(); }
}

// @Route("/GEN/DosyaPathAl")
export class BYS_DosyaPathAl extends BaseRequest<BYS_DosyaPathAl_Response> implements IReturn<BYS_DosyaPathAl_Response>
{
    public piReferansType: number;
    public piReferansNo: number;

    public constructor(init?: Partial<BYS_DosyaPathAl>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_DosyaPathAl'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_DosyaPathAl_Response(); }
}

// @Route("/BYS/SetBelgeIcerikKaydet")
export class BYS_SetBelgeIcerikKaydet extends BaseRequest<BYS_SetBelgeIcerikKaydet_Response> implements IReturn<BYS_SetBelgeIcerikKaydet_Response>
{
    public piIslemType: number;
    public piBelgeKod?: number;
    public piBelgeIcerik?: Object;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piColumnList: string;

    public constructor(init?: Partial<BYS_SetBelgeIcerikKaydet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SetBelgeIcerikKaydet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SetBelgeIcerikKaydet_Response(); }
}

// @Route("/BYS/BysBelgeIlgiAra")
export class BYS_BysBelgeIlgiAra extends BaseRequest<BYS_BysBelgeIlgiAra_Response> implements IReturn<BYS_BysBelgeIlgiAra_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBirimKod?: number;
    public piIlgiTuru?: string;
    public piReferansKod?: number;
    public piEvrakTarih?: string;
    public piEvrakNo?: number;
    public piIlgiAciklama?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_BysBelgeIlgiAra>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BysBelgeIlgiAra'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BysBelgeIlgiAra_Response(); }
}

// @Route("/BYS/AraBysBelgeDetay")
export class BYS_AraBysBelgeDetay extends BaseRequest<BYS_AraBysBelgeDetay_Response> implements IReturn<BYS_AraBysBelgeDetay_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBelgePath?: string;
    public piBelgeAd?: string;
    public piBelgeDysKod?: string;
    public piBelgeTipKod?: number;
    public piEimzaBelgeAd?: string;
    public piEimzaBelgeDysKod?: string;
    public piEimzaBelgeTipKod?: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysBelgeDetay>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysBelgeDetay'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysBelgeDetay_Response(); }
}

// @Route("/BYS/BysBelgeAsli")
export class BYS_BysBelgeAsli extends BaseRequest<BYS_BysBelgeAsli_Response> implements IReturn<BYS_BysBelgeAsli_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_BysBelgeAsli>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BysBelgeAsli'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BysBelgeAsli_Response(); }
}

// @Route("/BYS/BelgeOnayGonder")
export class BYS_BelgeOnayGonder_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piBirimKod: number;
    public piHavaleAciklama: string;

    public constructor(init?: Partial<BYS_BelgeOnayGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeOnayGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/GelenEvrakGonder")
export class BYS_GelenEvrakGonder extends BaseRequest<BYS_GelenEvrakGonder_Response> implements IReturn<BYS_GelenEvrakGonder_Response>
{
    public piBelgeKod: number;
    public piEvrakTarih: string;
    public piEvrakNo: number;
    public piZimmetTarih: string;
    public piZimmetNo: number;

    public constructor(init?: Partial<BYS_GelenEvrakGonder>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenEvrakGonder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GelenEvrakGonder_Response(); }
}

// @Route("/BYS/HavaleIadeGerekce")
export class BYS_HavaleIadeGerekce extends BaseRequest<BYS_HavaleIadeGerekce_Response> implements IReturn<BYS_HavaleIadeGerekce_Response>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_HavaleIadeGerekce>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_HavaleIadeGerekce'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_HavaleIadeGerekce_Response(); }
}

// @Route("/BYS/SetEvrakNo")
export class BYS_SetEvrakNo extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piBirimKod: number;
    public piEvrakTarih: string;
    public piEvrakNo: number;
    public piZimmetTarih: string;
    public piZimmetNo: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<BYS_SetEvrakNo>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SetEvrakNo'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeIncele")
export class BYS_BelgeIncele extends BYS_BelgeIncele_Response
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBelgePath?: string;
    public piBelgeAd?: string;
    public piBelgeDysKod?: string;
    public piBelgeTipKod?: number;
    public piEimzaBelgeAd?: string;
    public piEimzaBelgeDysKod?: string;
    public piEimzaBelgeTipKod?: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_BelgeIncele>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeIncele'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/BYS/ImzaGorevlerimiGetirTum")
export class BYS_ImzaGorevlerimiGetirTum extends BaseRequest<BYS_ImzaGorevlerimiGetirTum_Response> implements IReturn<BYS_ImzaGorevlerimiGetirTum_Response>
{
    public pKullaniciKod: number;
    public pSorguTuru: number;
    public piReferansKod: number;
    public piIcerik: string;
    public piGeldigiYer: number;
    public piGelisTarihi: string;
    public pStart?: number;
    public pLimit?: number;
    public piSiralama: string;
    public piBirimAd: string;
    public piBelgeAd: string;

    public constructor(init?: Partial<BYS_ImzaGorevlerimiGetirTum>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_ImzaGorevlerimiGetirTum'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_ImzaGorevlerimiGetirTum_Response(); }
}

// @Route("/BYS/EkBelgeGetir")
export class BYS_EkBelgeGetir extends BaseRequest<BYS_EkBelgeGetir_Response> implements IReturn<BYS_EkBelgeGetir_Response>
{
    public pBelgeKod: number;
    public pStart?: number;
    public pLimit?: number;

    public constructor(init?: Partial<BYS_EkBelgeGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_EkBelgeGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_EkBelgeGetir_Response(); }
}

// @Route("/BYS/ArsivGetir")
export class BYS_ArsivGetir extends BaseRequest<BYS_ArsivGetir_Response> implements IReturn<BYS_ArsivGetir_Response>
{
    public pArsivKod: number;
    public pStart?: number;
    public pLimit?: number;

    public constructor(init?: Partial<BYS_ArsivGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_ArsivGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_ArsivGetir_Response(); }
}

// @Route("/BYS/SpArsivSurec")
export class BYS_GetArsivSurecGoster extends BaseRequest<BYS_GetArsivSurecGoster_Response> implements IReturn<BYS_GetArsivSurecGoster_Response>
{
    public pArsivKod: number;
    public pStart?: number;
    public pLimit?: number;

    public constructor(init?: Partial<BYS_GetArsivSurecGoster>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetArsivSurecGoster'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetArsivSurecGoster_Response(); }
}

// @Route("/BYS/SurecIzle")
export class BYS_GetSurecIzle extends BaseRequest<BYS_GetSurecIzle_Response> implements IReturn<BYS_GetSurecIzle_Response>
{
    public pGorevDetayKod: number;
    public pStart?: number;
    public pLimit?: number;

    public constructor(init?: Partial<BYS_GetSurecIzle>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetSurecIzle'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetSurecIzle_Response(); }
}

export class BYS_BelgeUrlGetir extends BaseRequest<BYS_BelgeUrlGetir_Response> implements IReturn<BYS_BelgeUrlGetir_Response>
{
    public eImzaBelgeDysKod: number;
    public dosyaAdi: string;

    public constructor(init?: Partial<BYS_BelgeUrlGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeUrlGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BelgeUrlGetir_Response(); }
}

// @Route("/GAS/ArsivBelgeUrlGetir")
export class BYS_ArsivBelgeUrlGetir extends BaseRequest<BYS_ArsivBelgeUrlGetir_Response> implements IReturn<BYS_ArsivBelgeUrlGetir_Response>
{
    public piKod: number;
    public dosyaAdi: string;

    public constructor(init?: Partial<BYS_ArsivBelgeUrlGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_ArsivBelgeUrlGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_ArsivBelgeUrlGetir_Response(); }
}

// @Route("/BYS/EkBelgeUrlGetir")
export class BYS_EkBelgeUrlGetir extends BaseRequest<BYS_EkBelgeUrlGetir_Response> implements IReturn<BYS_EkBelgeUrlGetir_Response>
{
    public pKod: number;
    public dosyaAdi: string;

    public constructor(init?: Partial<BYS_EkBelgeUrlGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_EkBelgeUrlGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_EkBelgeUrlGetir_Response(); }
}

// @Route("/BYS/BelgeUzerineAl")
export class BYS_SurecGorevUzerineAl_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piGorevDetayKod: number;

    public constructor(init?: Partial<BYS_SurecGorevUzerineAl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecGorevUzerineAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeSerbestBirak")
export class BYS_SurecGorevSerbestBirak_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piGorevDetayKod: number;

    public constructor(init?: Partial<BYS_SurecGorevSerbestBirak_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecGorevSerbestBirak_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/SetGorevYap")
export class BYS_SetGorevYap implements IReturn<FnIntResponse>
{
    public piGorevDetayKod: number;

    public constructor(init?: Partial<BYS_SetGorevYap>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SetGorevYap'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/BYS/TokenKontrol")
export class BYS_TokenKontrol extends BaseRequest<BYS_TokenKontrol_Response> implements IReturn<BYS_TokenKontrol_Response>
{

    public constructor(init?: Partial<BYS_TokenKontrol>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TokenKontrol'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_TokenKontrol_Response(); }
}

// @Route("/BYS/KullaniciBilgileriYukle")
export class BYS_KullaniciBilgileriYukle extends BaseRequest<BYS_KullaniciBilgileriYukle_Response> implements IReturn<BYS_KullaniciBilgileriYukle_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_KullaniciBilgileriYukle>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KullaniciBilgileriYukle'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_KullaniciBilgileriYukle_Response(); }
}

export class BYS_SurecGorevYap_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public gorevDetayKod: number;
    public gorevAciklama: string;
    public belgeKod: number;
    public imzaKaynak: string;
    public pin: string;

    public constructor(init?: Partial<BYS_SurecGorevYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecGorevYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/SurecGorevIptal")
export class BYS_SurecGorevIptal_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public gorevDetayKod: number;
    public gorevAciklama: string;
    public belgeKod: number;
    public content: string;
    public contentGuncelleEh: string;

    public constructor(init?: Partial<BYS_SurecGorevIptal_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecGorevIptal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/DmlBysDegisen")
export class BYS_DmlBysDegisen extends BaseRequest<BYS_DmlBysDegisen_Response> implements IReturn<BYS_DmlBysDegisen_Response>
{
    public piIslemType: number;
    public piBelgeKod?: number;
    public piSurecKod?: number;
    public piIcerik?: Object;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piColumnList: string;

    public constructor(init?: Partial<BYS_DmlBysDegisen>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_DmlBysDegisen'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_DmlBysDegisen_Response(); }
}

// @Route("/BYS/BelgeHavaleKapat")
export class BYS_BelgeHavaleKapat_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piHavaleKod: number;
    public piSonucAciklama: string;

    public constructor(init?: Partial<BYS_BelgeHavaleKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeHavaleKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeHavaleReddet")
export class BYS_BelgeHavaleReddet_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piHavaleKod: number;
    public piSonucAciklama: string;

    public constructor(init?: Partial<BYS_BelgeHavaleReddet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeHavaleReddet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


// @Route("/BYS/BelgeOnay")
export class BYS_GelenBelgeDagitimOnay_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piHavaleKod: number;

    public constructor(init?: Partial<BYS_GelenBelgeDagitimOnay_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenBelgeDagitimOnay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeKapat")
export class BYS_GelenBelgeDagitimRed_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piHavaleKod: number;
    public piSonucAciklama: string;

    public constructor(init?: Partial<BYS_GelenBelgeDagitimRed_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenBelgeDagitimRed_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/GorevDetayGetir")
export class BYS_GorevDetayGetir extends BaseRequest<BYS_GorevDetayGetir_Response> implements IReturn<BYS_GorevDetayGetir_Response>
{
    public pKullaniciKod: number;
    public pSorguTuru: number;
    public piReferansKod: number;
    public piIcerik: string;
    public piGeldigiYer: number;
    public piGelisTarihi: string;
    public pStart?: number;
    public pLimit?: number;
    public piSiralama: string;
    public piBirimAd: string;
    public piBelgeAd: string;

    public constructor(init?: Partial<BYS_GorevDetayGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GorevDetayGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GorevDetayGetir_Response(); }
}

// @Route("/BYS/BelgeHavaleYap")
export class BYS_BelgeHavaleYap_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piEvrakKod: number;
    public piBirimKod: number;
    public piPersonelKod: number;
    public piHavaleAciklama: string;
    public piHavaleTipi: string;
    public piDevirHavaleEh: string;
    public piDevirHavaleKod: number;

    public constructor(init?: Partial<BYS_BelgeHavaleYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeHavaleYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/AraBysIlgiEk")
export class BYS_AraBysIlgiEk extends BaseRequest<BYS_AraBysIlgiEk_Response> implements IReturn<BYS_AraBysIlgiEk_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBirimKod?: number;
    public piIlgiTuru?: string;
    public piReferansKod?: number;
    public piEvrakTarih?: string;
    public piEvrakNo?: number;
    public piIlgiAciklama?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysIlgiEk>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysIlgiEk'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysIlgiEk_Response(); }
}

// @Route("/BYS/SurecIptal")
export class BYS_SurecIptal_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piSurecGorevKod: number;
    public piGorevDetayKod: number;
    public piGorevAciklama: string;

    public constructor(init?: Partial<BYS_SurecIptal_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecIptal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class BYS_ImzaDosyaGoster extends BaseRequest<BYS_ImzaDosyaGoster_Response> implements IReturn<BYS_ImzaDosyaGoster_Response>
{
    public dysId: number;
    public dosyaAdi: string;

    public constructor(init?: Partial<BYS_ImzaDosyaGoster>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_ImzaDosyaGoster'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_ImzaDosyaGoster_Response(); }
}

// @Route("/BYS/TaslakWordBelgeGetir")
export class BYS_TaslakWordBelgeGetir extends BaseRequest<BYS_TaslakWordBelgeGetir_Response> implements IReturn<BYS_TaslakWordBelgeGetir_Response>
{
    public piKod?: number;
    public piReferansKod?: number;
    public piBirimKod?: number;
    public piGelenGiden?: string;
    public piBelgeTuru?: string;
    public piGelenBirimKod?: number;
    public piGelenBirimAciklama?: string;
    public piBelgeTarih?: string;
    public piBelgeNo?: string;
    public piGenelDosyaNo?: number;
    public piDosyaPlanKod?: string;
    public piBelgeTuruKod?: number;
    public piBelgeAdi?: string;
    public piBelgeAciklama?: string;
    public piAnahtarKelime?: string;
    public piDagitimSekli?: string;
    public piOncelikDurumu?: string;
    public piBeklenenDonusTarih?: string;
    public piPersonelKod?: number;
    public piKisiKod?: number;
    public piTcknNo?: number;
    public piGuvenlikDurumu?: number;
    public piGecerliSure?: number;
    public piDilKod?: number;
    public piBelgeIcerikKod?: number;
    public piBilgiEdinmeEh?: string;
    public piKisiselEh?: string;
    public piTelifKapsamindaEh?: string;
    public piKelimeIslemci?: string;
    public piBarkodNo?: string;
    public piGelisTurKod?: number;
    public piAsliAlindiEh?: string;
    public piEvrakTuru?: string;
    public piTransferTarih?: string;
    public piArsivTarih?: string;
    public piImhaTarih?: string;
    public piUretimTarih?: string;
    public piUretimAciklama?: string;
    public piKlasorKod?: number;
    public piGonderAlTarih?: string;
    public piYazilimVersion?: string;
    public piGenelArsivKod?: number;
    public piStatusu?: number;
    public piDilekceEh?: string;
    public piEvrakTarih?: string;
    public piEvrakNo?: number;
    public piZimmetTarih?: string;
    public piZimmetNo?: number;
    public piOzelNo?: string;
    public piPafta?: string;
    public piAda?: number;
    public piParsel?: number;
    public piParselKod?: number;
    public piGsmTelefonNo?: string;
    public piEMail?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;
    public piSiralama?: string;
    public piGelenBirimAd?: string;
    public piBirimAd?: string;
    public piGelenEvrakDurumu?: string;

    public constructor(init?: Partial<BYS_TaslakWordBelgeGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TaslakWordBelgeGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_TaslakWordBelgeGetir_Response(); }
}

// @Route("/BYS/AraBysParametre")
export class BYS_AraBysParametre extends BaseRequest<BYS_AraBysParametre_Response> implements IReturn<BYS_AraBysParametre_Response>
{
    public piKod?: number;
    public piModulKod?: number;
    public piRaporBaslik1?: string;
    public piRaporBaslik2?: string;
    public piRaporBaslik3?: string;
    public piRaporBaslik4?: string;
    public piCalismaPath?: string;
    public piBelgeRootPath?: string;
    public piEimzaEh?: string;
    public piDilKod?: number;
    public piGenelBirimKod?: number;
    public piMevzuatLink?: string;
    public piEmailBaslikSatir?: string;
    public piEmailSonucSatir?: string;
    public piEvrakNoOtoEh?: string;
    public piSistemBelgeOtoArsivEh?: string;
    public piBelgeDogrulamaUrl?: string;
    public piZamanDamgaUrl?: string;
    public piZamanDamgaKullanici?: string;
    public piZamanDamgaSifre?: string;
    public piZamanDamgaProv?: string;
    public piAZamanDamgaUrl?: string;
    public piAZamanDamgaKullanici?: string;
    public piAZamanDamgaSifre?: string;
    public piAZamanDamgaProv?: string;
    public piEImzaUrl?: string;
    public piYaziMudurKod?: number;
    public piOtoOnayEh?: string;
    public piGelenBelgeOtoNoEh?: string;
    public piBelgeIcerikKod?: number;
    public piGelisTurKod?: number;
    public piOnayTurKod?: number;
    public piDysTuru?: string;
    public piDysServisAdres?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysParametre>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysParametre'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysParametre_Response(); }
}

// @Route("/BYS/SpDagitimBirim")
export class BYS_SpDagitimBirim extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_SpDagitimBirim>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SpDagitimBirim'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/SpDagitimMeclis")
export class BYS_DagitimMeclis extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_DagitimMeclis>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_DagitimMeclis'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/AraBysBelgeIcerik")
export class BYS_AraBysBelgeIcerik extends BaseRequest<BYS_AraBysBelgeIcerik_Response> implements IReturn<BYS_AraBysBelgeIcerik_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBelgeIcerik?: Object;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysBelgeIcerik>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysBelgeIcerik'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysBelgeIcerik_Response(); }
}

// @Route("/BYS/TaslakCopy")
export class BYS_TaslakCopy extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piSdpKodu: string;
    public piBirimKod: number;

    public constructor(init?: Partial<BYS_TaslakCopy>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TaslakCopy'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeGoster")
export class BYS_BelgeTaslakGoster extends BaseRequest<BYS_BelgeTaslakGoster_Response> implements IReturn<BYS_BelgeTaslakGoster_Response>
{
    public pKod: number;

    public constructor(init?: Partial<BYS_BelgeTaslakGoster>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeTaslakGoster'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BelgeTaslakGoster_Response(); }
}

// @Route("/BYS/AraBysSurec")
export class BYS_WordAraBysSurec extends BaseRequest<BYS_WordAraBysSurec_Response> implements IReturn<BYS_WordAraBysSurec_Response>
{
    public piKod?: number;
    public piBirimKod?: number;
    public piAd?: string;
    public piAktifEh?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_WordAraBysSurec>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_WordAraBysSurec'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_WordAraBysSurec_Response(); }
}

// @Route("/BYS/AraBysSurec")
export class BYS_AraBysSurec extends BaseRequest<BYS_AraBysSurec_Response> implements IReturn<BYS_AraBysSurec_Response>
{
    public piKod?: number;
    public piBirimKod?: number;
    public piAd?: string;
    public piAktifEh?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysSurec>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysSurec'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysSurec_Response(); }
}

// @Route("/BYS/AraBysSurecDetay")
export class BYS_AraBysSurecDetay extends BaseRequest<BYS_AraBysSurecDetay_Response> implements IReturn<BYS_AraBysSurecDetay_Response>
{
    public piKod?: number;
    public piSurecKod?: number;
    public piGorevKod?: number;
    public piGorevAd?: string;
    public piRolAd?: string;
    public piGorevTuru?: number;
    public piImzaEh?: string;
    public piZamanDamgaEh?: string;
    public piMailEh?: string;
    public piSmsEh?: string;
    public piSonrakiGorevKod?: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysSurecDetay>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysSurecDetay'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysSurecDetay_Response(); }
}

// @Route("/BYS/ImzaKontrol")
export class BYS_ImzaKontrol extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_ImzaKontrol>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_ImzaKontrol'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/SurecYarat")
export class BYS_SurecYarat_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piSurecKod: number;
    public piBelgeKod: number;
    public piBirimKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<BYS_SurecYarat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecYarat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class BYS_SurecHazirla_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<BYS_SurecHazirla_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/SurecHazirla")
export class BYS_SurecHazirla_Request extends BaseRequest<BYS_SurecHazirla_Response> implements IReturn<BYS_SurecHazirla_Response>
{
    public piSurecKod: number;
    public piBelgeKod: number;
    public piBirimKod: number;

    public constructor(init?: Partial<BYS_SurecHazirla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecHazirla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SurecHazirla_Response(); }
}

// @Route("/BYS/AraBysBelgeDetay")
export class BYS_AraBysBelgeDetay2 extends BaseRequest<BYS_AraBysBelgeDetay_Response2> implements IReturn<BYS_AraBysBelgeDetay_Response2>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piBelgePath?: string;
    public piBelgeAd?: string;
    public piBelgeDysKod?: string;
    public piBelgeTipKod?: number;
    public piEimzaBelgeAd?: string;
    public piEimzaBelgeDysKod?: string;
    public piEimzaBelgeTipKod?: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysBelgeDetay2>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysBelgeDetay2'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysBelgeDetay_Response2(); }
}

// @Route("/BYS/AraBysGorev")
export class BYS_AraBysGorev extends BaseRequest<BYS_AraBysGorev_Response> implements IReturn<BYS_AraBysGorev_Response>
{
    public piKod?: number;
    public piSurecKod?: number;
    public piBirimKod?: number;
    public piBelgeKod?: number;
    public piBaslamaTarih?: string;
    public piBitisTarih?: string;
    public piSonucTuru?: number;
    public piSonucAciklama?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysGorev>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysGorev'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysGorev_Response(); }
}

// @Route("/BYS/AraBysGorevDetay")
export class BYS_AraBysGorevDetay extends BaseRequest<BYS_AraBysGorevDetay_Response> implements IReturn<BYS_AraBysGorevDetay_Response>
{
    public piKod?: number;
    public piSurecGorevKod?: number;
    public piGorevKod?: number;
    public piGorevAd?: string;
    public piRolAd?: string;
    public piGorevTuru?: number;
    public piImzaEh?: string;
    public piZamanDamgaEh?: string;
    public piMailEh?: string;
    public piSmsEh?: string;
    public piSonrakiGorevKod?: number;
    public piPersonelKod?: number;
    public piGorevBaslamaTarih?: string;
    public piGorevBitisTarih?: string;
    public piAktifGorevEh?: string;
    public piGorevTamamlandiEh?: string;
    public piGorevSonucTuru?: number;
    public piAciklama?: string;
    public piImzaOnayTuru?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysGorevDetay>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysGorevDetay'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysGorevDetay_Response(); }
}

// @Route("/BYS/SpIadeGerekce")
export class BYS_IadeGerekce extends BaseRequest<BYS_IadeGerekce_Response> implements IReturn<BYS_IadeGerekce_Response>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_IadeGerekce>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_IadeGerekce'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_IadeGerekce_Response(); }
}

export class BYS_GidenEvrakKayit_Response extends BaseResponse
{
    public poDonenEvrakNo: number;

    public constructor(init?: Partial<BYS_GidenEvrakKayit_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/Taslak/SpEvrakKayit")
export class BYS_GidenEvrakKayit_Request extends BaseRequest<BYS_GidenEvrakKayit_Response> implements IReturn<BYS_GidenEvrakKayit_Response>
{
    public piBelgeKod: number;
    public piEvrakTarih: string;
    public piEvrakNo: number;
    public piZimmetTarih: string;
    public piZimmetNo: number;

    public constructor(init?: Partial<BYS_GidenEvrakKayit_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GidenEvrakKayit_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GidenEvrakKayit_Response(); }
}


// @Route("/BYS/KarsilastirmaGetir")
export class BYS_KarsilastirmaGetir extends BaseRequest<BYS_KarsilastirmaGetir_Response> implements IReturn<BYS_KarsilastirmaGetir_Response>
{
    public piBelgeKod: number;
    public piDegisKod: number;

    public constructor(init?: Partial<BYS_KarsilastirmaGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KarsilastirmaGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_KarsilastirmaGetir_Response(); }
}

// @Route("/BYS/KisiBilgisiGetir")
export class BYS_KisiBilgisiGetir extends BaseRequest<BYS_KisiBilgisiGetir_Response> implements IReturn<BYS_KisiBilgisiGetir_Response>
{
    public piKisiKod: number;

    public constructor(init?: Partial<BYS_KisiBilgisiGetir>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KisiBilgisiGetir'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_KisiBilgisiGetir_Response(); }
}

// @Route("/BYS/BysBelgeDagitim")
export class BYS_TopluDagitimKaydet extends BaseRequest<BYS_TopluDagitimKaydet_Response> implements IReturn<BYS_TopluDagitimKaydet_Response>
{
    public piIslemType: number;
    public piBelgeKod?: number;
    public piBirimKod?: number;
    public piAciklama?: string;
    public piDagitimSekli?: string;
    public piIslemTuru?: string;
    public piRedNedeni?: string;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piColumnList?: string;

    public constructor(init?: Partial<BYS_TopluDagitimKaydet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TopluDagitimKaydet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_TopluDagitimKaydet_Response(); }
}

// @Route("/BYS/AraBysSurec")
export class BYS_BirimSurecDoldur extends BaseRequest<BYS_BirimSurecDoldur_Response> implements IReturn<BYS_BirimSurecDoldur_Response>
{
    public piKod?: number;
    public piBirimKod?: number;
    public piAd?: string;
    public piAktifEh?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_BirimSurecDoldur>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BirimSurecDoldur'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BirimSurecDoldur_Response(); }
}

// @Route("/BYS/TaslakSablonDoldur")
export class BYS_TaslakSablonDoldur extends BaseRequest<BYS_TaslakSablonDoldur_Response> implements IReturn<BYS_TaslakSablonDoldur_Response>
{
    public piKod: number;
    public piAciklama: string;
    public piDosyaPlanKod: string;
    public piBirimKod: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_TaslakSablonDoldur>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TaslakSablonDoldur'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_TaslakSablonDoldur_Response(); }
}

// @Route("/BYS/BelgeImzalari")
export class BYS_BelgeImzalari extends BaseRequest<BYS_BelgeImzalari_Response> implements IReturn<BYS_BelgeImzalari_Response>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_BelgeImzalari>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeImzalari'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BelgeImzalari_Response(); }
}

// @Route("/BYS/AraBysBelgeTarama")
export class BYS_AraBysBelgeTarama extends BaseRequest<BYS_AraBysBelgeTarama_Response> implements IReturn<BYS_AraBysBelgeTarama_Response>
{
    public piKod?: number;
    public piDosyaAd?: string;
    public piDosyaPath?: string;
    public piTabloAdi?: string;
    public piTabloKod?: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysBelgeTarama>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysBelgeTarama'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysBelgeTarama_Response(); }
}

// @Route("/BYS/SablonOnaylanmayanTasi")
export class BYS_SablonOnaylanmayanTasi extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_SablonOnaylanmayanTasi>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SablonOnaylanmayanTasi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/TaslakBilgiAlanlariYukle")
export class BYS_TaslakBilgiAlanlariYukle extends BaseRequest<BYS_TaslakBilgiAlanlariYukle_Response> implements IReturn<BYS_TaslakBilgiAlanlariYukle_Response>
{
    public piKod: number;

    public constructor(init?: Partial<BYS_TaslakBilgiAlanlariYukle>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TaslakBilgiAlanlariYukle'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_TaslakBilgiAlanlariYukle_Response(); }
}

// @Route("/BYS/PgBysServis/SpBelgeKaydet")
export class Bys_SpBelgeKaydet_Request extends BaseRequest<Bys_SpBelgeKaydet_Response> implements IReturn<Bys_SpBelgeKaydet_Response>
{
    public pioKod: number;
    public piIslemType: number;
    public piReferansKod?: number;
    public piBirimKod?: number;
    public piGelenGiden?: string;
    public piBelgeTuru?: string;
    public piGelenBirimKod?: number;
    public piGelenBirimAciklama?: string;
    public piBelgeTarih?: string;
    public piBelgeNo?: string;
    public piGenelDosyaNo?: number;
    public piDosyaPlanKod?: string;
    public piBelgeTuruKod?: number;
    public piBelgeAdi?: string;
    public piBelgeAciklama?: string;
    public piAnahtarKelime?: string;
    public piDagitimSekli?: string;
    public piOncelikDurumu?: string;
    public piBeklenenDonusTarih?: string;
    public piPersonelKod?: number;
    public piKisiKod?: number;
    public piTcknNo?: number;
    public piGuvenlikDurumu?: number;
    public piGecerliSure?: number;
    public piDilKod?: number;
    public piBelgeIcerikKod?: number;
    public piBilgiEdinmeEh?: string;
    public piKisiselEh?: string;
    public piTelifKapsamindaEh?: string;
    public piKelimeIslemci?: string;
    public piBarkodNo?: string;
    public piGelisTurKod?: number;
    public piAsliAlindiEh?: string;
    public piEvrakTuru?: string;
    public piTransferTarih?: string;
    public piArsivTarih?: string;
    public piImhaTarih?: string;
    public piUretimTarih?: string;
    public piUretimAciklama?: string;
    public piKlasorKod?: number;
    public piGonderAlTarih?: string;
    public piYazilimVersion?: string;
    public piGenelArsivKod?: number;
    public piStatusu?: number;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piDilekceEh?: string;
    public piZimmetTarih?: string;
    public piZimmetNo?: number;
    public piOzelNo?: string;
    public piPafta?: string;
    public piAda?: number;
    public piParsel?: number;
    public piParselKod?: number;
    public piGsmTelefonNo?: string;
    public piEMail?: string;
    public piColumnList?: string;
    public piSurecKod?: number;
    public piTaslakKod?: number;
    public piImzaPersonelKod?: number;
    public piYeniEditor?: number;

    public constructor(init?: Partial<Bys_SpBelgeKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_SpBelgeKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_SpBelgeKaydet_Response(); }
}

// @Route("/BYS/AraBysEvrak")
export class BYS_AraBysEvrak extends BaseRequest<BYS_AraBysEvrak_Response> implements IReturn<BYS_AraBysEvrak_Response>
{
    public piKod?: number;
    public piBelgeKod?: number;
    public piDagitimKod?: number;
    public piBirimKod?: number;
    public piGelenGiden?: string;
    public piEvrakTuru?: string;
    public piEvrakTarih?: string;
    public piEvrakNo?: number;
    public piZimmetTarih?: string;
    public piZimmetNo?: number;
    public piGenelArsivKod?: number;
    public piAciklama?: string;
    public piBirimNot?: string;
    public piPostaNot?: string;
    public piTebligNot?: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<BYS_AraBysEvrak>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_AraBysEvrak'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_AraBysEvrak_Response(); }
}

// @Route("/BYS/SetUstBilgiSurecUpdate")
export class BYS_SetUstBilgiSurecUpdate extends BaseRequest<BYS_SetUstBilgiSurecUpdate_Response> implements IReturn<BYS_SetUstBilgiSurecUpdate_Response>
{
    public piRaporAdi: string;
    public piTabloAdi: string;
    public piReferansKod: number;
    public piAltTabloAdi: string;
    public piAltReferansKod: number;
    public piPersonelKod: number;
    public piKisiKod: number;
    public piTckn: number;
    public piArsivKod: number;
    public piBirimKod: number;
    public piBelgeAciklama: string;

    public constructor(init?: Partial<BYS_SetUstBilgiSurecUpdate>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SetUstBilgiSurecUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SetUstBilgiSurecUpdate_Response(); }
}

// @Route("/BYS/TaslakBelgeGirisSil")
export class BYS_TaslakBelgeGirisSil_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piAciklama: string;

    public constructor(init?: Partial<BYS_TaslakBelgeGirisSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TaslakBelgeGirisSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/GetIcBirimlerListe")
export class BYS_GetIcBirimlerListe extends BaseRequest<BYS_GetIcBirimlerListe_Response> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_GetIcBirimlerListe>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetIcBirimlerListe'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class BYS_GetIcBirimlerListe_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value:any[];

    public constructor(init?: Partial<BYS_GetIcBirimlerListe_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_EypOlusturKontrol extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_EypOlusturKontrol>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_EypOlusturKontrol'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

/** @description Sign In */
// @Route("/auth", "OPTIONS,GET,POST,DELETE")
// @Route("/auth/{provider}", "OPTIONS,GET,POST,DELETE")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public returnUrl: string;

    // @DataMember(Order=21)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// export class GetDocumentContentResponse extends BaseResponse
// {
//     public dysContent: string;
//     public dysPath?: string;
//     public dysName: string;
//     public dysType: string;

//     public constructor(init?: Partial<GetDocumentContentResponse>) { super(init); (Object as any).assign(this, init); }
// }

// // @Route("/BYS/GetDocumentContent")
// export class GetDocumentContent extends BaseRequest<GetDocumentContentResponse> implements IReturn<GetDocumentContentResponse>
// {
//     public dysId: number;
//     public dysDocumentName: string;

//     public constructor(init?: Partial<GetDocumentContent>) { super(init); (Object as any).assign(this, init); }
//     public getTypeName() { return 'GetDocumentContent'; }
//     public getMethod() { return 'POST'; }
//     public createResponse() { return new GetDocumentContentResponse(); }
// }

export class BYS_GetDocumentContent_Response extends BaseResponse
{
    public dysKod: number;
    public dysContent: string;
    public dysPath?: string;
    public dysName: string;
    public dysType: string;

    public constructor(init?: Partial<BYS_GetDocumentContent_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GetDocumentContent")
export class BYS_GetDocumentContent_Request extends BaseRequest<BYS_GetDocumentContent_Response> implements IReturn<BYS_GetDocumentContent_Response>
{
    public kaynak: string;
    public belgeKod: number;
    public detayKod: number;
    public dysId: number;
    public updateContent: boolean;

    public constructor(init?: Partial<BYS_GetDocumentContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetDocumentContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetDocumentContent_Response(); }
}



// @Route("/BYS/GetDocumentWithBelgeKod")
// export class GetDocumentWithBelgeKod extends BaseRequest<GetDocumentContentResponse> implements IReturn<GetDocumentContentResponse>
// {
//     public belgeKod: number;

//     public constructor(init?: Partial<GetDocumentWithBelgeKod>) { super(init); (Object as any).assign(this, init); }
//     public getTypeName() { return 'GetDocumentWithBelgeKod'; }
//     public getMethod() { return 'POST'; }
//     public createResponse() { return new GetDocumentContentResponse(); }
// }
export class GetDocumentPathResponse extends BaseResponse
{
    public dysContent: string;
    public res: string;

    public constructor(init?: Partial<GetDocumentPathResponse>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GetDocumentPath")
export class GetDocumentPath extends BaseRequest<GetDocumentPathResponse> implements IReturn<GetDocumentPathResponse>
{
    public belgeKod: number;
    public referenceType: number;

    public constructor(init?: Partial<GetDocumentPath>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDocumentPath'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetDocumentPathResponse(); }
}



export class BYS_TaslakTasi_Response extends BaseResponse
{

    public constructor(init?: Partial<BYS_TaslakTasi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_TaslakTasi extends BaseRequest<BYS_TaslakTasi_Response> implements IReturn<BYS_TaslakTasi_Response>
{
    public belgeKod: number;
    public eskiBelgeKod: number;

    public constructor(init?: Partial<BYS_TaslakTasi>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_TaslakTasi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_TaslakTasi_Response(); }
}

export class BYS_SablonKaydet_Response extends BaseResponse
{

    public constructor(init?: Partial<BYS_SablonKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_SablonKaydet extends BaseRequest<BYS_SablonKaydet_Response> implements IReturn<BYS_SablonKaydet_Response>
{
    public birimKod: number;
    public sdpKod: string;
    public aciklama?: string;
    public belgeKod: number;

    public constructor(init?: Partial<BYS_SablonKaydet>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SablonKaydet'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SablonKaydet_Response(); }
}


export class CreateDocumentResponse extends BaseResponse
{
    public documentId: number;

    public constructor(init?: Partial<CreateDocumentResponse>) { super(init); (Object as any).assign(this, init); }
}

export class CreateDocument extends BaseRequest<CreateDocumentResponse> implements IReturn<CreateDocumentResponse>
{
    public folderId: number;
    public fileName: string;
    public content: string;

    public constructor(init?: Partial<CreateDocument>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDocumentResponse(); }
}



export class CreateDocumentWithFolderName extends BaseRequest<CreateDocumentResponse> implements IReturn<CreateDocumentResponse>
{
    public folderName: string;
    public fileName: string;
    public content: string;

    public constructor(init?: Partial<CreateDocumentWithFolderName>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDocumentWithFolderName'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDocumentResponse(); }
}


// export class UploadDocumentResponse extends BaseResponse
// {
//     public dysId: number;
//     public dysName: string;
//     public dysPath: string;

//     public constructor(init?: Partial<UploadDocumentResponse>) { super(init); (Object as any).assign(this, init); }
// }

// export class UploadDocument extends BaseRequest<UploadDocumentResponse> implements IReturn<UploadDocumentResponse>
// {
//     public belgeKod: number;
//     public content: string;
//     public isBelgeAsil: boolean;
//     public isUpdate: boolean;

//     public constructor(init?: Partial<UploadDocument>) { super(init); (Object as any).assign(this, init); }
//     public getTypeName() { return 'UploadDocument'; }
//     public getMethod() { return 'POST'; }
//     public createResponse() { return new UploadDocumentResponse(); }
// }



export class BYS_UploadDocument_Response extends BaseResponse
{
    public dysId: number;
    public dysName: string;
    public dysPath: string;

    public constructor(init?: Partial<BYS_UploadDocument_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/UploadDocument")
export class BYS_UploadDocument_Request extends BaseRequest<BYS_UploadDocument_Response> implements IReturn<BYS_UploadDocument_Response>
{
    public documentTip: string;
    public belgeKod: number;
    public content: string;
    public isBelgeAsil: boolean;
    public isUpdate: boolean;

    public constructor(init?: Partial<BYS_UploadDocument_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UploadDocument_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_UploadDocument_Response(); }
}



export class EditTemplateResponse extends BaseResponse
{

    public constructor(init?: Partial<EditTemplateResponse>) { super(init); (Object as any).assign(this, init); }
}

export class EditTemplate extends BaseRequest<EditTemplateResponse> implements IReturn<EditTemplateResponse>
{
    public sdpKod: string;
    public birimKod: number;
    public aciklama?: string;
    public dysId?: number;
    public dysName?: string;
    public templateContent: string;

    public constructor(init?: Partial<EditTemplate>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'EditTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EditTemplateResponse(); }
}


export class GetTemplateResponse extends BaseResponse
{
    public templateContent: string;
    public dysPath: string;
    public dysId: number;

    public constructor(init?: Partial<GetTemplateResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetTemplate extends BaseRequest<GetTemplateResponse> implements IReturn<GetTemplateResponse>
{
    public taslakKod: number;

    public constructor(init?: Partial<GetTemplate>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetTemplateResponse(); }
}

export class WordDocSignList
{
    public imzaAdSoyad: string;
    public imzaGorev1: string;
    public imzaGorev2: string;
    public gorevKod: string;

    public constructor(init?: Partial<WordDocSignList>) { (Object as any).assign(this, init); }
}

export class WordDocumentInfo
{
    public baslik1: string;
    public baslik2: string;
    public baslik3: string;
    public sayi: string;
    public sayiDetay: string;
    public konu: string;
    public hitap: string;
    public ekler: string;
    public dagitim: string;
    public bilgiOrGeregi: string;
    public ilgi: string;
    public ilgiBaslik: string;
    public ilgiDetay: string;
    public dogrulamaAdres: string;
    public adres: string;
    public ad: string;
    public telefonNo: string;
    public unvan: string;
    public webAdres: string;
    public bTel: string;
    public imza11: string;
    public imza12: string;
    public imza13: string;
    public imza21: string;
    public imza22: string;
    public imza23: string;
    public imza31: string;
    public imza32: string;
    public imza33: string;
    public gorevKod: string;
    public kepAdres: string;
    public oncelikDurum: string;
    public cevapTarihi: string;
    public dysContent: string;
    public dysId: string;

    public constructor(init?: Partial<WordDocumentInfo>) { (Object as any).assign(this, init); }
}
export class GetWordDocumentInfoResponse extends BaseResponse
{
    public wordDocumentInfo: WordDocumentInfo;

    public constructor(init?: Partial<GetWordDocumentInfoResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetWordDocumentInfo extends BaseRequest<GetWordDocumentInfoResponse> implements IReturn<GetWordDocumentInfoResponse>
{
    public belgeKod: number;

    public constructor(init?: Partial<GetWordDocumentInfo>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWordDocumentInfo'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetWordDocumentInfoResponse(); }
}

export class GetDefaultTemplate extends BaseRequest<GetTemplateResponse> implements IReturn<GetTemplateResponse>
{

    public constructor(init?: Partial<GetDefaultTemplate>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDefaultTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetTemplateResponse(); }
}


export class BYS_SablonTasi_Response extends BaseResponse
{

    public constructor(init?: Partial<BYS_SablonTasi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_SablonTasi extends BaseRequest<BYS_SablonTasi_Response> implements IReturn<BYS_SablonTasi_Response>
{
    public sablonKod: number;
    public belgeKod: number;

    public constructor(init?: Partial<BYS_SablonTasi>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SablonTasi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_SablonTasi_Response(); }
}

export class Bys_BelgeDagitimEkle_Response extends BaseResponse
{
    public belgeDagitimlar: BysBelgeDagitim[];

    public constructor(init?: Partial<Bys_BelgeDagitimEkle_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/BelgeDagitimEkle")
export class Bys_BelgeDagitimEkle_Request extends BaseRequest<Bys_BelgeDagitimEkle_Response> implements IReturn<Bys_BelgeDagitimEkle_Response>
{
    public belgeKod: number;
    public dagitimSablonKod: number;
    public birimKodlar: number[];
    public bilgiGeregi: string;
    public kaynakDagitimKod: number;

    public constructor(init?: Partial<Bys_BelgeDagitimEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_BelgeDagitimEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_BelgeDagitimEkle_Response(); }
}

export class Bys_DagitimBirimEkle_Response extends BaseResponse
{
    public dagitimBirimler: BysDagitimBirim[];

    public constructor(init?: Partial<Bys_DagitimBirimEkle_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/DagitimBirimEkle")
export class Bys_DagitimBirimEkle_Request extends BaseRequest<Bys_DagitimBirimEkle_Response> implements IReturn<Bys_DagitimBirimEkle_Response>
{
    public dagitimSablonKod: number;
    public birimKodlar: number[];
    public bilgiGeregi: string;

    public constructor(init?: Partial<Bys_DagitimBirimEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_DagitimBirimEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_DagitimBirimEkle_Response(); }
}



export class KisiBilgisi
{
    public tckn: string;
    public adSoyad: string;
    public unvan: string;

    public constructor(init?: Partial<KisiBilgisi>) { (Object as any).assign(this, init); }
}

export class EkBelge
{
    public dosyaAdi?: string;
    public dosyaIcerik?: string;

    public constructor(init?: Partial<EkBelge>) { (Object as any).assign(this, init); }
}

export class Ilgi
{
    public belgeNo?: string;
    public etiket?: string;
    public tarih?: string;
    public ad?: string;
    public aciklama?: string;

    public constructor(init?: Partial<Ilgi>) { (Object as any).assign(this, init); }
}

export class EYPPackage
{
    public sdpKodu: string;
    public gelenBirimKod: number;
    public gelenBirimAd: string;
    public belgeNo: string;
    public konu: string;
    public gizlilik: string;
    public oncelik: string;
    public belgeTarihi: string;
    public dosyaPlanAciklama: string;
    public beklenenTarih: string;
    public imzaBilgileri: KisiBilgisi[];
    public ilgililer: KisiBilgisi[];
    public ekBelgeler: EkBelge[];
    public ilgiler: Ilgi[];
    public ustYaziPdfContent: string;
    public kepGelisKodu: string;
    public dilKod:number;
    public dosyaPlanKod:number;
    public belgeTuruKod:number;
    public guvenlikKodu:number;

    public constructor(init?: Partial<EYPPackage>) { (Object as any).assign(this, init); }
}



export class BYS_KepGonder_Response extends BaseResponse
{

    public constructor(init?: Partial<BYS_KepGonder_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BYS_KepGonder extends BaseRequest<BYS_KepGonder_Response> implements IReturn<BYS_KepGonder_Response>
{
    public belgeKod: number;
    public dagitimKod: number;

    public constructor(init?: Partial<BYS_KepGonder>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KepGonder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_KepGonder_Response(); }
}


export class Bys_SertifikaBilgi
{
    public signerName: string;
    public signerUserSSN: string;
    public signerProvider: string;
    public signerCertStartDate: string;
    public signerCertEndDate: string;
    public isValid: boolean;
    public validationMessages: string;

    public constructor(init?: Partial<Bys_SertifikaBilgi>) { (Object as any).assign(this, init); }
}

export class Bys_GetGorevDetay_Response extends BaseResponse
{
    public gorevDetayKod: number;
    public personelKod: number;
    public kullaniciKod: number;
    public adSoyad: string;
    public soyadi: string;
    public tckn: string;
    public gsmTelefon: string;
    public gorevTuru: string;
    public onayTuru: string;
    public imzaDurum: string;
    public imzaEh: string;
    public pinZorunluEh: string;
    public gorevDetay: Bys_GorevDetayDto;
    public sertifikaBilgi: Bys_SertifikaBilgi;

    public constructor(init?: Partial<Bys_GetGorevDetay_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GetGorevDetay")
export class Bys_GetGorevDetay_Request extends BaseRequest<Bys_GetGorevDetay_Response> implements IReturn<Bys_GetGorevDetay_Response>
{
    public gorevDetayKod: number;

    public constructor(init?: Partial<Bys_GetGorevDetay_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_GetGorevDetay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_GetGorevDetay_Response(); }
}

// @Route("/BYS/BelgeTakipEt")
export class Bys_BelgeTakipEt_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piKullanicIKlasorKod?: number;

    public constructor(init?: Partial<Bys_BelgeTakipEt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_BelgeTakipEt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


// @Route("/BYS/BelgeTakipBirak")
export class Bys_BelgeTakipBirak_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<Bys_BelgeTakipBirak_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_BelgeTakipBirak_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}



// @Route("/BYS/BelgeOnaylanmayanaTası")
export class BYS_BelgeOnaylanmayanaTasi_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_BelgeOnaylanmayanaTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeOnaylanmayanaTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeTaslagaTasi")
export class BYS_BelgeTaslagaTasi_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_BelgeTaslagaTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeTaslagaTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class BysSablonDosyaKaydet_Response extends BaseResponse
{
    public documentId: number;
    public documentName: string;

    public constructor(init?: Partial<BysSablonDosyaKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/BysSablonDosya")
export class BysSablonDosyaKaydet_Request extends BaseRequest<BysSablonDosyaKaydet_Response> implements IReturn<BysSablonDosyaKaydet_Response>
{
    public sablonKod: number;
    public documentContent: string;
    public documentName: string;
    public documentPath: string;

    public constructor(init?: Partial<BysSablonDosyaKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BysSablonDosyaKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BysSablonDosyaKaydet_Response(); }
}

export class Bys_Download extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public dysId: string;

    public constructor(init?: Partial<Bys_Download>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_Download'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaseResponse(); }
}


export class BYS_UploadContent_Response extends BaseResponse
{
    public dysId: number;
    public dysName: string;
    public dysPath: string;

    public constructor(init?: Partial<BYS_UploadContent_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/UploadContent")
export class BYS_UploadContent_Request extends BaseRequest<BYS_UploadContent_Response> implements IReturn<BYS_UploadContent_Response>
{
    public belgeKod: number;
    public content: string;

    public constructor(init?: Partial<BYS_UploadContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UploadContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_UploadContent_Response(); }
}


export class BYS_UploadEkBelge_Response extends BaseResponse
{
    public dysId: number;
    public dysName: string;
    public dysPath: string;

    public constructor(init?: Partial<BYS_UploadEkBelge_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/UploadEkBelge")
export class BYS_UploadEkBelge_Request extends BaseRequest<BYS_UploadEkBelge_Response> implements IReturn<BYS_UploadEkBelge_Response>
{
    public belgeKod: number;
    public belgeEkKod: number;
    public dosyaAd?: string;
    public content?: string;
    public belgeNo?: number;
    public belgeAciklama?: string;
    public belgeTipKod?: number;
    public belgeTarih?: string;
    public adetSayfa?: string;
    public fizikselBelgeEh?: string;
    // LOG-ANALIZ 29.10: Belge Türü ayrı alan (BYS_BELGE_EK.BELGE_TURU_KOD)
    public belgeTuruKod?: number;

    public constructor(init?: Partial<BYS_UploadEkBelge_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UploadEkBelge_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_UploadEkBelge_Response(); }
}


export class BYS_GetWordDocument_Response extends BaseResponse
{
    public docContent: string;

    public constructor(init?: Partial<BYS_GetWordDocument_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GetWordDocument")
export class BYS_GetWordDocument_Request extends BaseRequest<BYS_GetWordDocument_Response> implements IReturn<BYS_GetWordDocument_Response>
{
    public belgeKod: number;
    public createYn: boolean;
    public taslakKod: number;

    public constructor(init?: Partial<BYS_GetWordDocument_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetWordDocument_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetWordDocument_Response(); }
}

// @Route("/BYS/BelgeHavaleReddet")
export class BYS_GelenBelgeKapat_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piEvrakKod: number;
    public piSonucTurKod: number;
    public piSonucAciklama: string;

    public constructor(init?: Partial<BYS_GelenBelgeKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenBelgeKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeCokluHavaleYap")
export class BYS_BelgeCokluHavaleYap_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piEvrakKod: number;
    public piBirimKod: number;
    public piPersonelKodlar: number[];
    public piHavaleAciklama: string;
    public piHavaleTipi: string;

    public constructor(init?: Partial<BYS_BelgeCokluHavaleYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeCokluHavaleYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/BelgeCokluEvrakHavaleYap")
export class BYS_BelgeCokluEvrakHavaleYap_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piEvrakKodlar: number[];
    public piBirimKod: number;
    public piPersonelKodlar: number[];
    public piHavaleAciklama: string;
    public piHavaleTipi: string;

    public constructor(init?: Partial<BYS_BelgeCokluEvrakHavaleYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeCokluEvrakHavaleYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/GelenBirimEvrakKapat")
export class BYS_GelenBirimEvrakKapat_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piEvrakKod: number;
    public piBelgeKod: number;
    public piKapatmaAciklama: string;
    public piKapatmaTipi: number;

    public constructor(init?: Partial<BYS_GelenBirimEvrakKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenBirimEvrakKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class BYS_EYPMuhurle_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public belgeKod: number;
    public muhurPIN: string;

    public constructor(init?: Partial<BYS_EYPMuhurle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_EYPMuhurle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class BYS_GelenEvrakCevapOlustur_Response extends BaseResponse
{
    public gidenBelgeKod: number;

    public constructor(init?: Partial<BYS_GelenEvrakCevapOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GelenEvrakCevapOlustur")
export class BYS_GelenEvrakCevapOlustur_Request extends BaseRequest<BYS_GelenEvrakCevapOlustur_Response> implements IReturn<BYS_GelenEvrakCevapOlustur_Response>
{
    public piEvrakKod: number;
    public piBelgeKod: number;
    public piSDPKod: string;
    public piBelgeAciklama: string;
    public piGidenBirimKod: number;
    // DKM-5050 Clara: Evrak Bilgi Kaynagi ('personel' | 'birim'); bos ise servis BYS.TASLAK_BELGE_BILGI_KAYNAK parametresine bakar
    public piBilgiKaynak?: string;

    public constructor(init?: Partial<BYS_GelenEvrakCevapOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenEvrakCevapOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GelenEvrakCevapOlustur_Response(); }
}

// @Route("/BYS/GetDocumentUstYazi")
export class BYS_GetDocumentUstYazi_Request extends BaseRequest<BYS_GetDocumentContent_Response> implements IReturn<BYS_GetDocumentContent_Response>
{
    public belgeKod: number;
    public tarihEkleEh: string;

    public constructor(init?: Partial<BYS_GetDocumentUstYazi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetDocumentUstYazi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetDocumentContent_Response(); }
}



export class BYS_KepGelenBelgeOlustur_Response extends BaseResponse
{
    public gelenBelgeKod: number;

    public constructor(init?: Partial<BYS_KepGelenBelgeOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/KepGelenBelgeOlustur")
export class BYS_KepGelenBelgeOlustur_Request extends BaseRequest<BYS_KepGelenBelgeOlustur_Response> implements IReturn<BYS_KepGelenBelgeOlustur_Response>
{
    public kepKod: number;
    // DKM-5502 Cedric: EYP'li KEP formunda kullanıcının seçtikleri (isteğe bağlı; boşsa servis eski davranışı sürdürür)
    public gelenBirimKod?: number;
    public dosyaPlanKod?: string;
    public belgeAdi?: string;
    public belgeAciklama?: string;

    public constructor(init?: Partial<BYS_KepGelenBelgeOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KepGelenBelgeOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_KepGelenBelgeOlustur_Response(); }
}
// DKM-5502 Cedric: EYP paketi olmayan (yalnız PDF) KEP'ten gelen belge oluşturma
export class BYS_KepPdfGelenBelgeOlustur_Response extends BaseResponse
{
    public gelenBelgeKod: number;

    public constructor(init?: Partial<BYS_KepPdfGelenBelgeOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/KepPdfGelenBelgeOlustur")
export class BYS_KepPdfGelenBelgeOlustur_Request extends BaseRequest<BYS_KepPdfGelenBelgeOlustur_Response> implements IReturn<BYS_KepPdfGelenBelgeOlustur_Response>
{
    public kepKod: number;
    public ustYaziEkKod: number;
    public ekKodlar: number[];
    public gelenBirimKod: number;
    public dosyaPlanKod: string;
    public belgeAdi: string;
    public belgeNo: string;
    public belgeTarih: string;
    public belgeAciklama: string;

    public constructor(init?: Partial<BYS_KepPdfGelenBelgeOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KepPdfGelenBelgeOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_KepPdfGelenBelgeOlustur_Response(); }
}
// @Route("/BYS/KepGonder")
export class BYS_GidenBelgeKepGonder_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public belgeKod: number;
    public dagitimKod: number;
    public kepAdres: string;
    public pin: string;

    public constructor(init?: Partial<BYS_GidenBelgeKepGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GidenBelgeKepGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


// @Route("/BYS/PostaGonder")
export class BYS_GidenBelgePostaGonder_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public belgeKod: number;
    public dagitimKod: number;
    public gonderimAdres: string;
    public gonderimNot: string;
    public gonderimBedeli: number;
    // DKM-5047 Clara: elle girilen gonderim (posta) tarihi 'yyyy-MM-dd'; bos ise servis bugunu yazar
    public gonderimTarih?: string;

    public constructor(init?: Partial<BYS_GidenBelgePostaGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GidenBelgePostaGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/GidenBelgeGonder")
export class BYS_GidenBelgeGonder_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public belgeKod: number;
    public dagitimKod: number;
    public gonderimTipi: string;
    public gonderimNot: string;
    public gonderimAdres: string;
    public gonderimBedeli: number;
    public postaTuruKod?: number;
    // DKM-5047 Clara: elle girilen gonderim (posta) tarihi 'yyyy-MM-dd'; bos ise servis bugunu yazar
    public gonderimTarih?: string;

    public constructor(init?: Partial<BYS_GidenBelgeGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GidenBelgeGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/GetDocumentUstYaziOnIzleme")
export class BYS_GetDocumentUstYaziOnIzleme_Request extends BaseRequest<BYS_GetDocumentContent_Response> implements IReturn<BYS_GetDocumentContent_Response>
{
    public belgeKod: number;
    public tarihEkleEh: string;

    public constructor(init?: Partial<BYS_GetDocumentUstYaziOnIzleme_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetDocumentUstYaziOnIzleme_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetDocumentContent_Response(); }
}

// @Route("/BYS/BelgeOnayKapat")
export class BYS_GelenBelgeDagitimRedCevap_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public dagitimKod: number;
    public aciklama: string;
    public dagitimSekli: string;
    public cevapTuru: number;

    public constructor(init?: Partial<BYS_GelenBelgeDagitimRedCevap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GelenBelgeDagitimRedCevap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class RemAddressInfo
{
    public remAddressId: number;
    public remSpId: number;
    public remAdress: string;
    public userSSN: string;
    public officerCode: string;
    public password: string;
    public expireDate?: string;

    public constructor(init?: Partial<RemAddressInfo>) { (Object as any).assign(this, init); }
}

export class Bys_GetKepAdresInfo_Response extends BaseResponse
{
    public remAddress: RemAddressInfo;

    public constructor(init?: Partial<Bys_GetKepAdresInfo_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/Bys/GetRemAddresses")
export class Bys_GetKepAdresInfo_Request implements IReturn<Bys_GetKepAdresInfo_Response>
{

    public constructor(init?: Partial<Bys_GetKepAdresInfo_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_GetKepAdresInfo_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_GetKepAdresInfo_Response(); }
}

export class Bys_LoginPtt_Response extends BaseResponse
{
    public remAddress: RemAddressInfo;

    public constructor(init?: Partial<Bys_LoginPtt_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/Bys/LoginPtt2")
export class Bys_LoginPtt_Request implements IReturn<Bys_LoginPtt_Response>
{
    public userSSN: string;
    public officerCode: string;
    public password: string;

    public constructor(init?: Partial<Bys_LoginPtt_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_LoginPtt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_LoginPtt_Response(); }
}
export class Bys_GorevDetayDto
{
    public gorevDetayKod: number;
    public belgeKonu: string;
    public imzaEh: string;
    public gorevTuru: string;
    public onayTuru: string;
    public imzaDurum: string;

    public constructor(init?: Partial<Bys_GorevDetayDto>) { (Object as any).assign(this, init); }
}
export class Bys_GetGorevDetayList_Response extends BaseResponse
{
    public personelKod: number;
    public kullaniciKod: number;
    public adSoyad: string;
    public soyadi: string;
    public tckn: string;
    public gsmTelefon: string;
    public imzaEh: string;
    public pinZorunluEh: string;
    public gorevDetayList: Bys_GorevDetayDto[];
    public sertifikaBilgi: Bys_SertifikaBilgi;

    public constructor(init?: Partial<Bys_GetGorevDetayList_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GetGorevDetayList")
export class Bys_GetGorevDetayList_Request extends BaseRequest<Bys_GetGorevDetayList_Response> implements IReturn<Bys_GetGorevDetayList_Response>
{
    public gorevDetayKodList: number[];

    public constructor(init?: Partial<Bys_GetGorevDetayList_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_GetGorevDetayList_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_GetGorevDetayList_Response(); }
}

export class BYS_BelgeKopyala_Response extends BaseResponse
{
    public belgeKod: number;

    public constructor(init?: Partial<BYS_BelgeKopyala_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/BelgeKopyala")
export class BYS_BelgeKopyala_Request extends BaseRequest<BYS_BelgeKopyala_Response> implements IReturn<BYS_BelgeKopyala_Response>
{
    public piBelgeKod: number;
    public piIcerikhEh: string;
    public piDagitimEh: string;
    public piEkBelgeEh: string;
    public piBelgeAcıklama: string;

    public constructor(init?: Partial<BYS_BelgeKopyala_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_BelgeKopyala_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_BelgeKopyala_Response(); }
}

// @Route("/BYS/UstYaziSil")
export class BYS_UstYaziSil_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;

    public constructor(init?: Partial<BYS_UstYaziSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UstYaziSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/KepAl")
export class BYS_KepAl_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<BYS_KepAl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KepAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class EypKisiBilgisi
{
    public tckn: string;
    public adSoyad: string;
    public unvan: string;

    public constructor(init?: Partial<EypKisiBilgisi>) { (Object as any).assign(this, init); }
}

export class EypEkBelge
{
    public dosyaAdi: string;
    public dysKod: string;
    public dosyaIcerik?: string;

    public constructor(init?: Partial<EypEkBelge>) { (Object as any).assign(this, init); }
}

export class EypIlgi
{
    public belgeNo?: string;
    public etiket?: string;
    public tarih?: string;
    public ad?: string;
    public aciklama?: string;

    public constructor(init?: Partial<EypIlgi>) { (Object as any).assign(this, init); }
}

export class EYPDosya
{
    public sdpKodu: string;
    public gelenBirimKod: number;
    public gelenBirimAd: string;
    public belgeNo: string;
    public belgeAd: string;
    public konu: string;
    public guvenlikKodu: number;
    public oncelik: string;
    public dilKod?: number;
    public belgeTarih?: string;
    public beklenenDonusTarih?: string;
    public dosyaPlanAciklama: string;
    public dosyaPlanKod: string;
    public beklenenTarih: string;
    public belgeTuruKod: number;
    public guvenlikDurumu: number;
    public oncelikDurumu: string;
    public imzaBilgileri: EypKisiBilgisi[];
    public ilgililer: EypKisiBilgisi[];
    public ekBelgeler: EypEkBelge[];
    public ilgiler: EypIlgi[];
    public imzaBilgileriText: string;
    public ilgilerText: string;
    public ekBelgelerText: string;
    public ilgılerText: string;
    public ustYaziDysKod: string;
    public ustYaziPdfContent: string;
    public kepGelisKodu: string;
    public paketVersiyonu: string;
    public uyariList: string[];
    // DKM-5502 Cedric: EYP'deki gönderen birimin DETSİS numarası (yoksa boş) ve belge numarasından okunan SDP kodu
    public gelenBirimKimlikNo?: string;
    public eypSdpKodu?: string;

    public constructor(init?: Partial<EYPDosya>) { (Object as any).assign(this, init); }
}
export class BYS_EypDosyaOku_Response extends BaseResponse
{
    public eypIcerik: EYPDosya;

    public constructor(init?: Partial<BYS_EypDosyaOku_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/EypDosyaOku")
export class BYS_EypDosyaOku_Request extends BaseRequest<BYS_EypDosyaOku_Response> implements IReturn<BYS_EypDosyaOku_Response>
{
    public kaynak: string;
    public kaynakKod: number;
    public kepEkKod: number;
    public eypDysId: string;
    // DKM-5502 Cedric: true ise EYP'de DETSİS no yoksa hata yerine uyarı döner (varsayılan false)
    public birimsizDevam?: boolean;

    public constructor(init?: Partial<BYS_EypDosyaOku_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_EypDosyaOku_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_EypDosyaOku_Response(); }
}


// @Route("/BYS/RebuildWordDocument")
export class BYS_RebuildWordDocument_Request extends BaseRequest<BYS_GetWordDocument_Response> implements IReturn<BYS_GetWordDocument_Response>
{
    public belgeKod: number;
    public docContent: string;
    public saveYn: boolean;

    public constructor(init?: Partial<BYS_RebuildWordDocument_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_RebuildWordDocument_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetWordDocument_Response(); }
}


// @Route("/Bys/SertifikaBilgi")
export class Bys_SertifikaBilgi_Request extends BaseRequest<Bys_GetGorevDetay_Response> implements IReturn<Bys_GetGorevDetay_Response>
{
    public ssn: string;

    public constructor(init?: Partial<Bys_SertifikaBilgi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_SertifikaBilgi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_GetGorevDetay_Response(); }
}

// @Route("/BYS/CreatePdfFromImage/")
export class Bys_CreatePdfFromImage_Request extends BaseRequest<BYS_GetDocumentContent_Response> implements IReturn<BYS_GetDocumentContent_Response>
{
    public imageList: string[];

    public constructor(init?: Partial<Bys_CreatePdfFromImage_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_CreatePdfFromImage_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetDocumentContent_Response(); }
}

export class BYS_GetBelgeBilgi_Response extends BaseResponse
{
    public belgeKod: number;
    public evrakKod: number;
    public belgeAciklama: string;
    public belgeDurum: string;
    public evrakNo: string;
    public evrakTarih: string;
    public evrakTipi: string;

    public constructor(init?: Partial<BYS_GetBelgeBilgi_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/GetBelgeBilgi")
export class BYS_GetBelgeBilgi_Request extends BaseRequest<BYS_GetBelgeBilgi_Response> implements IReturn<BYS_GetBelgeBilgi_Response>
{
    public belgeKod: number;
    public evrakKod: number;
    public dagitimKod: number;

    public constructor(init?: Partial<BYS_GetBelgeBilgi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_GetBelgeBilgi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetBelgeBilgi_Response(); }
}

export class CMY_UploadBasvuruBelge_Response extends BaseResponse
{
    public dysId: number;
    public dysName: string;
    public dysPath: string;

    public constructor(init?: Partial<CMY_UploadBasvuruBelge_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/CMY/UploadBasvuruBelge")
export class CMY_UploadBasvuruBelge_Request extends BaseRequest<CMY_UploadBasvuruBelge_Response> implements IReturn<CMY_UploadBasvuruBelge_Response>
{
    public basvuruKod: number;
    public belgeKod: number;
    public belgeTipKod: number;
    public belgeAd: string;
    public content: string;
    public aciklama?: string;
    public islemTarih?: string;

    public constructor(init?: Partial<CMY_UploadBasvuruBelge_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CMY_UploadBasvuruBelge_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CMY_UploadBasvuruBelge_Response(); }
}

export class YIS_UploadKararBelge_Response extends BaseResponse
{
    public dysId: number;
    public dysName: string;
    public dysPath: string;

    public constructor(init?: Partial<YIS_UploadKararBelge_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/YIS/UploadKararBelge")
export class YIS_UploadKararBelge_Request extends BaseRequest<YIS_UploadKararBelge_Response> implements IReturn<YIS_UploadKararBelge_Response>
{
    public belgeKod: number;
    public kararKod: number;
    public belgeAd: string;
    public content: string;
    public belgeNo?: number;
    public belgeAciklama?: string;
    public belgeTipKod?: number;
    public belgeTuruKod?: number;
    public belgeTarih?: string;

    public constructor(init?: Partial<YIS_UploadKararBelge_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'YIS_UploadKararBelge_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new YIS_UploadKararBelge_Response(); }
}

export class YIS_GetDocumentContent_Response extends BaseResponse
{
    public dysKod: number;
    public dysContent: string;
    public dysPath?: string;
    public dysName: string;
    public dysType: string;

    public constructor(init?: Partial<YIS_GetDocumentContent_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/YIS/GetDocumentContent")
export class YIS_GetDocumentContent_Request extends BaseRequest<YIS_GetDocumentContent_Response> implements IReturn<YIS_GetDocumentContent_Response>
{
    public kaynak: string;
    public belgeKod: number;
    public detayKod: number;
    public dysId: number;

    public constructor(init?: Partial<YIS_GetDocumentContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'YIS_GetDocumentContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new YIS_GetDocumentContent_Response(); }
}
export class YIS_UploadBelge_Response extends BaseResponse
{
    public dysId: number;
    public dysName: string;
    public dysPath: string;

    public constructor(init?: Partial<YIS_UploadBelge_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/YIS/UploadGundemBelge")
export class YIS_UploadGundemBelge_Request extends BaseRequest<YIS_UploadBelge_Response> implements IReturn<YIS_UploadBelge_Response>
{
    public belgeKod: number;
    public gundemKod: number;
    public belgeAd: string;
    public content: string;
    public belgeNo?: number;
    public belgeAciklama?: string;
    public belgeTipKod?: number;
    public belgeTuruKod?: number;
    public belgeTarih?: string;

    public constructor(init?: Partial<YIS_UploadGundemBelge_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'YIS_UploadGundemBelge_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new YIS_UploadBelge_Response(); }
}

// @Route("/YIS/AddToplamtiGundem")
export class Yis_AddToplantiGundem_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public toplantiKod: number;
    public gundemKodlar: number[];

    public constructor(init?: Partial<Yis_AddToplantiGundem_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Yis_AddToplantiGundem_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class CMY_GetDocumentContent_Response extends BaseResponse
{
    public dysKod: number;
    public dysContent: string;
    public dysPath?: string;
    public dysName: string;
    public dysType: string;

    public constructor(init?: Partial<CMY_GetDocumentContent_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Yis_AddToplantiUye_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public toplantiKod: number;
    public uyeKodlar: number[];

    public constructor(init?: Partial<Yis_AddToplantiUye_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Yis_AddToplantiUye_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/GetDocumentContent")
export class CMY_GetDocumentContent_Request extends BaseRequest<CMY_GetDocumentContent_Response> implements IReturn<CMY_GetDocumentContent_Response>
{
    public kaynak: string;
    public belgeKod: number;
    public detayKod: number;
    public dysId: number;

    public constructor(init?: Partial<CMY_GetDocumentContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CMY_GetDocumentContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CMY_GetDocumentContent_Response(); }
}


// @Route("/YIS/GetKararWordContent")
export class YIS_GetKararWordContent_Request extends BaseRequest<BYS_GetWordDocument_Response> implements IReturn<BYS_GetWordDocument_Response>
{
    public kararKod: number;
    public createYn: boolean;
    public content: string;
    public taslakKod: number;

    public constructor(init?: Partial<YIS_GetKararWordContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'YIS_GetKararWordContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetWordDocument_Response(); }
}

// @Route("/YIS/UploadKararWordContent")
export class YIS_UploadKararWordContent_Request extends BaseRequest<BYS_GetWordDocument_Response> implements IReturn<BYS_GetWordDocument_Response>
{
    public kararKod: number;
    public content: string;

    public constructor(init?: Partial<YIS_UploadKararWordContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'YIS_UploadKararWordContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_GetWordDocument_Response(); }
}


// @Route("/BYS/KepDuzelt")
export class BYS_KepDuzelt_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public kepId: number;

    public constructor(init?: Partial<BYS_KepDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KepDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/KepDuzeltGiden")
export class BYS_KepDuzeltGiden_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public kepId: number;

    public constructor(init?: Partial<BYS_KepDuzeltGiden_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_KepDuzeltGiden_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class Bys_SpEvrakAraYeni_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: Object[];
    public islemKod: string;

    public constructor(init?: Partial<Bys_SpEvrakAraYeni_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DBY/PgdBysServis/SpEvrakAraYeni")
export class Bys_SpEvrakAraYeni_Request extends BaseRequest<Bys_SpEvrakAraYeni_Response> implements IReturn<Bys_SpEvrakAraYeni_Response>
{
    public piIlkTarih: string;
    public piSonTarih: string;
    public piEvrakTuru: string;
    public piGelenEvrakTarih: string;
    public piGelenEvrakNo: number;
    public piAramaSek: string;
    public piBelgeAdiEh: string;
    public piBelgeAciklamaEh: string;
    public piAnahtarKelimeEh: string;
    public piIcerikEh: string;
    public piAramaKriter: string;
    public piGeldigiYer: string;
    public piReferansKod: number;
    public piBelgeTarih: string;
    public piBelgeNo: string;
    public piEvrakTarih: string;
    public piEvrakNo: string;
    public piAda: string;
    public piParsel: string;
    public piBirimNot: string;
    public piIslemKod: string;

    

    public constructor(init?: Partial<Bys_SpEvrakAraYeni_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Bys_SpEvrakAraYeni_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Bys_SpEvrakAraYeni_Response(); }
}


// @Route("/BYS/SurecKalemIptal")
export class BYS_SurecKalemIptal_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piIptalAciklama: string;

    public constructor(init?: Partial<BYS_SurecKalemIptal_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_SurecKalemIptal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/UetsGelenMesajlarAl")
export class BYS_UetsGelenMesajlar_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<BYS_UetsGelenMesajlar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UetsGelenMesajlar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/UetsMesajGonder")
export class BYS_UetsMesajGonder_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public eypFileBytes: string;
    public fileName: string;
    public recipientAddress: string;
    public subject: string;
    public referenceId: string;
    public barcode: string;
    public dysId: string;

    public constructor(init?: Partial<BYS_UetsMesajGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UetsMesajGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/BYS/UetsKisiGuncelle")
export class BYS_UetsKisiGuncelle_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public kisiKod: number;

    public constructor(init?: Partial<BYS_UetsKisiGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UetsKisiGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class AuthorizedClientDto
{
    public name: string;
    public lastName: string;
    public title: string;

    public constructor(init?: Partial<AuthorizedClientDto>) { (Object as any).assign(this, init); }
}

export class RecipientDto
{
    public address?: string;
    public name?: string;
    public dtn?: string;
    public vgn?: string;
    public msn?: string;
    public activityArea?: string;
    public headOfficeAddress?: string;
    public physicalAddress?: string;
    public authorizedClients?: AuthorizedClientDto[];

    public constructor(init?: Partial<RecipientDto>) { (Object as any).assign(this, init); }
}

export class Bys_UetsAliciBul_Response extends BaseResponse
{
    public recipients: RecipientDto[];

    public constructor(init?: Partial<Bys_UetsAliciBul_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/BYS/UetsAliciBul")
export class BYS_UetsAliciBul_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public address?: string;
    public tcn?: string;
    public vgn?: string;
    public dtn?: string;
    public msn?: string;
    public occupation?: string;

    public constructor(init?: Partial<BYS_UetsAliciBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UetsAliciBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


// @Route("/BYS/UetsGelenBelgeOlustur")
export class BYS_UetsGelenBelgeOlustur_Request extends BaseRequest<BYS_KepGelenBelgeOlustur_Response> implements IReturn<BYS_KepGelenBelgeOlustur_Response>
{
    public uetsGelenKod: number;

    public constructor(init?: Partial<BYS_UetsGelenBelgeOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BYS_UetsGelenBelgeOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BYS_KepGelenBelgeOlustur_Response(); }
}